import { withSuspenseLazy } from 'react-with-suspense-lazy';

import { Loader } from '@components/Loader';
import { RoutesConfiguration } from '@components/RouterOutlet';
import { permissionsRoles } from '@config/permissions';

import { BookRoutePaths } from '../routesPaths';

const BookPage = withSuspenseLazy(
  () => import('./BookPage'),
  Loader,
);

const BookAdd = withSuspenseLazy(
  () => import('./BookAdd'),
  Loader,
);

const BookEdit = withSuspenseLazy(
  () => import('./BookEdit'),
  Loader,
);

export const BookRouteConfig: RoutesConfiguration = [
  {
    path: BookRoutePaths.bookRoot,
    component: BookPage,
    exact: true,
    permittedRoles: permissionsRoles.book,
  },
  {
    path: BookRoutePaths.bookAddPath,
    component: BookAdd,
    permittedRoles: permissionsRoles.book,
  },
  {
    path: BookRoutePaths.bookEditPath,
    component: BookEdit,
    permittedRoles: permissionsRoles.book,
  },
];
